const simpleAnalyticsEventsUrl = "https://queue.simpleanalyticscdn.com/events";
const isDev = import.meta.env.DEV;

type EventName =
	| "stars_clicked"
	| "detect_again_clicked"
	| "plagiarism_again_clicked"
	| "language_selected"
	| "detect_responded"
	| "plagiarism_responded"
	| "read_file_responded";

type MetricsData = {
	event: EventName;
	metadata?: Record<string, string | number | boolean>;
};

function getUserAgent(): string {
	if (typeof navigator !== "undefined" && navigator.userAgent) {
		return navigator.userAgent;
	}
	return "unknown";
}

export async function trackEvent(data: MetricsData) {
	if (isDev) {
		return;
	}
	try {
		await fetch(simpleAnalyticsEventsUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				...data,
				ua: getUserAgent(),
				type: "event",
				hostname: "https://www.ai-checker-for-teachers.com",
			}),
		});
	} catch (error) {
		console.error("Error in track event:", error);
	}
}
